export default __webpack_public_path__ + "static/media/social-events-mobile@2x.76b0735c.jpg";